import { createContext, useContext, useMemo } from "react";
import { getBrandConfig } from "../config/brandConfig";

const BrandContext = createContext(getBrandConfig());

export function BrandProvider({ children }) {
  const brand = useMemo(() => getBrandConfig(), []);
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
